export default {
  data() {
    return {
      recipient: {
        address: "",
        city: "",
        province: "",
        postalCode: "",
        latitude: "",
        longitude: "",
      },
    };
  },
  methods: {
    googleAutoComplete(addressComponent) {
      var element = addressComponent.$el.querySelector("input");

      if (!element) return;
      const autocomplete = new google.maps.places.Autocomplete(element, {
        types: ["geocode"],
        componentRestrictions: {
          country: this.$i18n.localeProperties.country.toLowerCase(),
        },
      });



      autocomplete.addListener("place_changed", () => {
        const place = autocomplete.getPlace();
        if (!place || !place.address_components || !place.geometry) return;

        const { address_components, geometry } = place;
        const { lat, lng } = geometry.location;
        this.recipient.latitude = lat().toString() || "";
        this.recipient.longitude = lng().toString() || "";

        const addressArray = [];
        address_components.forEach((component) => {
          const { long_name, short_name, types } = component;
          if (types.includes("street_number") || types.includes("route")) {
            addressArray.push(long_name);
          } else if (types.includes("locality")) {
            this.recipient.city = short_name;
          } else if (types.includes("administrative_area_level_1")) {
              this.recipient.province = (long_name === 'Québec')?'Quebec':long_name;
          } else if (types.includes("postal_code")) {
            this.recipient.postalCode = long_name;
          }
        });
        this.recipient.address = addressArray.join(" ");
      });

    },
    googleSecondAddressAutoComplete(addressComponent) {
      var element = addressComponent.$el.querySelector("input");

      if (!element) return;
      const shippingaddressautocomplete=new google.maps.places.Autocomplete(element, {
        types: ["geocode"],
        componentRestrictions: {
          country: this.$i18n.localeProperties.country.toLowerCase(),
        },
      });

      shippingaddressautocomplete.addListener("place_changed", () => {
        const shippingPlace = shippingaddressautocomplete.getPlace();
        if (!shippingPlace || !shippingPlace.address_components || !shippingPlace.geometry) return;

        const { address_components, geometry } = shippingPlace;
        const { lat, lng } = geometry.location;
        this.recipient.shippingLatitude = lat().toString() || "";
        this.recipient.shippingLongitude = lng().toString() || "";

        const shippingAddressArray = [];
        address_components.forEach((component) => {

          const { long_name, short_name, types } = component;
          if (types.includes("street_number") || types.includes("route")) {
            shippingAddressArray.push(long_name);
          } else if (types.includes("locality")) {
            this.recipient.shippingCity = short_name;
          } else if (types.includes("administrative_area_level_1")) {
            this.recipient.shippingProvince = (long_name === 'Québec')?'Quebec':long_name;
          } else if (types.includes("postal_code")) {
            this.recipient.shippingPostalCode = long_name;
          }
        });
        this.recipient.shippingAddress = shippingAddressArray.join(" ");
      });

    },
  },
};
